exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".Csv .dropzone p{margin:0;padding:2em;text-align:center;border:2px dashed #efefef;cursor:pointer}.Csv aside ul{height:2em;padding-top:.25em;font-size:1rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./~/postcss-loader!./src/components/CSV/CSV.scss
// module id = 734
// module chunks = 0